module.exports = __webpack_public_path__ + "img/e7622b7.jpg";